import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dual-time"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.formatted)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("strong", null, _toDisplayString($setup.formatted), 1 /* TEXT */)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.empty), 1 /* TEXT */))
}